import { CjsLogin, LinkOptions } from "@cervval.js/client-auth/src/components/login/login.component";
import { FLEX_CONTAINER_COLUMN, JUSTIFY_CONTENT } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { CustomElement, WebPageComponent } from "@cervval.js/client-html5-spa/navigation";
import { ClientRouteOptions, TypedClientAjaxProxy } from "@cervval.js/client-html5-spa/routes";
import { AuthInfos, AuthInfosRoutes, LoginFormAuthRoutes } from "@cervval.js/common-auth/src/authRoutes";
import { capitalizeFirstLetter } from "@cervval.js/common/src/tools/string.tools";

@CustomElement({
    name: "login-page",
    style: require("./login.page.scss"),
    elementCssClasses: [FLEX_CONTAINER_COLUMN, JUSTIFY_CONTENT.CENTER, "align-center"]
})
export class LoginPage extends WebPageComponent {

    @TypedClientAjaxProxy({ urlPrefix: "../" })
    public authInfosRoutes!: AuthInfosRoutes<ClientRouteOptions>;

    @TypedClientAjaxProxy({ urlPrefix: "../" })
    public loginFormAuthRoutes!: LoginFormAuthRoutes<unknown, ClientRouteOptions>;

    /**
     * init : first time the item is inserted into DOM
     */
    public override init(): Promise<void> {
        // Build login component
        return this.authInfosRoutes.getAuthInfos().then((authInfos: AuthInfos) => {
            if (authInfos.appDisplayName) {
                document.title = authInfos.appDisplayName;
            }
            const login: CjsLogin = new CjsLogin({
                appName: authInfos.appDisplayName,
                appLogoUrl: authInfos.appLogoUrl,
                login: (loginStr, password) => this.loginFormAuthRoutes.formLogin({ login: loginStr, password }, { doNotShowDialogOnErrors: true, doNotLogErrors: true }).then((loginResult) => {
                    if (loginResult.redirectAfterLogin) {
                        window.location.href = loginResult.redirectAfterLogin;
                    } else {
                        window.location.href = "..";
                    }
                }),
                ssoOptions: authInfos.singleSignOnOptions?.map((s) => {
                    const linkOptions: LinkOptions = {
                        iconCss: s.iconCss,
                        text: capitalizeFirstLetter(s.text),
                        tooltip: s.text,
                        callback: () => {
                            window.location.href = s.url;
                            return Promise.resolve(undefined);
                        }
                    };
                    return linkOptions;
                })
            });
            this.append(login);

            if (login.components) {
                login.components.appName.append(document.createElement("br"));
                login.components.appName.style.fontSize = "3em";
                const slogan = document.createElement("span");
                slogan.innerText = "Mixed Reality Training";
                slogan.style.fontSize = "37%";
                slogan.style.marginTop = "-6px";
                slogan.style.position = "relative";
                slogan.style.display = "block";
                login.components?.appName.append(slogan);
            }
        });
    }
}